import {Component, computed, input} from '@angular/core';
import {TranslocoDirective} from '@jsverse/transloco';
import {CommonModule} from '@angular/common';
import {MatButton} from '@angular/material/button';
import {LoyaltyLevel, PillLoyaltyComponent, LoyaltyCurrencyPipe} from 'shared-lib';
import {GhostMerchantBounty} from '../../../services/models/ghost-merchant-bounty';
import {MatIcon} from '@angular/material/icon';
import {Router} from '@angular/router';

@Component({
  selector: 'app-bounty-merchant-card',
  imports: [
    TranslocoDirective,
    CommonModule,
    MatButton,
    PillLoyaltyComponent,
    LoyaltyCurrencyPipe,
    MatIcon
  ],
  templateUrl: './bounty-merchant-card.component.html',
  styleUrl: './bounty-merchant-card.component.scss'
})
export class BountyMerchantCardComponent {
  bounty = input.required<GhostMerchantBounty>();

  protected readonly LoyaltyLevel = LoyaltyLevel;

  hasProgress = computed(() => !!this.bounty().progress);

  constructor(private router: Router) {
  }

  onRequestRewards(): void {
    const _ = this.router.navigate(['/bounty-invitation'], {
      state: {bounty: this.bounty()}
    });
  }

  getFirstLetter(): string {
    return this.bounty().merchant.name?.charAt(0).toUpperCase() || '';
  }

  isStepCompleted(step: number): boolean {
    const progress = this.bounty().progress;
    if (!progress) return false;

    switch (step) {
      case 1:
        return progress.userRegistered;
      case 2:
        return progress.campaignCreated;
      case 3:
        return progress.rewarded;
      default:
        return false;
    }
  }

  getMonthlySpendFormatted(): string {
    const monthlySpend = this.bounty().amount || 0;
    return `$${Math.round(monthlySpend)}/m`;
  }
}
